if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer') || document.querySelector('cart-items');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.pdpSlideDownBox = this.querySelector('.to-cart-checkout-box');
      this.pdpSlideDownMessageQty = this.querySelector('#atc-added-message .qty');
    }

    hidePDPSlideDown() {
      if (!!window.abVarSet?.useDrawerCart) {
        this.pdpSlideDownBox.remove();
      } else {
        this.pdpSlideDownBox.classList.remove("opened-box");
      }
    }

    showPDPSlideDown(addedQty) {
      if (addedQty) {
        this.pdpSlideDownMessageQty.innerText = addedQty > 1 ? `${addedQty} items` : '1 item';
      }

      let scrollWait = 0;
      const windowHeight = window.innerHeight;
      const maxDistance = this.pdpSlideDownBox.parentElement.getBoundingClientRect().top + 156 + Math.min(84, windowHeight * 0.1); /* Exp#01 */

      if (maxDistance > windowHeight) {
        const distanceToScroll = (maxDistance - windowHeight) + 1;
        scrollWait = distanceToScroll;
        window.scrollBy({
          top: distanceToScroll,
          behavior: 'smooth'
        });
      }

      setTimeout(() => this.pdpSlideDownBox.classList.add("opened-box"), scrollWait);
    }

    trackEvent(hasSellingPlan) {
      if (hasSellingPlan) {
        window._vis_opt_queue = window._vis_opt_queue || [];
        window._vis_opt_queue.push(function() {_vis_opt_goal_conversion(204);});
      } else {
        window._vis_opt_queue = window._vis_opt_queue || [];
        window._vis_opt_queue.push(function() {_vis_opt_goal_conversion(205);});
      }
    }

    trackScent(scent) {
      switch (scent.toLowerCase()) {
        case 'peppermint':
          window._vis_opt_queue = window._vis_opt_queue || [];
          window._vis_opt_queue.push(function() {_vis_opt_goal_conversion(207);});
          break;
        case 'cedarwood':
          window._vis_opt_queue = window._vis_opt_queue || [];
          window._vis_opt_queue.push(function() {_vis_opt_goal_conversion(208);});
          break;
        case 'lemongrass':
          window._vis_opt_queue = window._vis_opt_queue || [];
          window._vis_opt_queue.push(function() {_vis_opt_goal_conversion(209);});
          break;
        case 'rosemary':
          window._vis_opt_queue = window._vis_opt_queue || [];
          window._vis_opt_queue.push(function() {_vis_opt_goal_conversion(210);});
          break;
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      if (this.pdpSlideDownBox) {
        this.hidePDPSlideDown();
      }
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.section));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      /* if (window.location.pathname.indexOf("/products/") > -1) { */
        const selling_plan = config.body.get('selling_plan');
        this.trackEvent(!!selling_plan);

        /* const scent = config.body.get('Scent selection');
        if (scent) {
          this.trackScent(scent);
        } */
      /* } */

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          let targetAutoCode = window.getAutoApplyCode();
          if (!!targetAutoCode && !response.discounts.some(da => da.title.toLowerCase() === targetAutoCode)) {
            fetch(`${window.location.origin}/discount/${targetAutoCode}`);
          }

          /* Go#102023 */
          if (response.sku.toLowerCase().indexOf("virtual") > -1) {
            document.cookie = `vbhbatc=true; expires=${new Date(((new Date()) * 1) + (3*24*60*60*1000))}; path=/`;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else if (this.pdpSlideDownBox) {
            this.cart.renderContents(response,true);
            if (!!window.abVarSet?.useDrawerCart) {
              window.Rebuy.SmartCart.show();
              this.hidePDPSlideDown();
            } else {
              this.showPDPSlideDown(config.body.get('quantity'));
              window.Rebuy.SmartCart.hide();
              $("#rebuy-cart")[0].style.display = 'none';
              const rbUnhideTimeout = setTimeout(() => {
                window.Rebuy.SmartCart.hide();
                $("#rebuy-cart")[0].style.display = '';
              }, 2000);
              $(".slidedown-btn.to-cart").on('click',() => {
                clearTimeout(rbUnhideTimeout);
                $("#rebuy-cart")[0].style.display = '';
                window.Rebuy.SmartCart.show();
              })
            }
          } else {
            this.cart.renderContents(response,false);
          }

          /* TODO : Go#120323c */
          const currDate = new Date() * 1;
          const startDate = new Date("Fri Oct 25 2024 00:00:00 GMT-0600 (Central Standard Time)") * 1;
          const endDate = currDate * 0;// new Date("Fri Nov 01 2024 23:59:00 GMT-0600 (Central Standard Time)") * 1;
          if (currDate >= startDate && currDate <= endDate) {
            fetch(window.Shopify.routes.root + 'cart.js').then((response) => {
              return response.text();
            }).then((state) => {
              const parsedState = JSON.parse(state);
              if (parsedState.item_count > 0) {
                /* TODO : Go#120323b */
                const free_gift_variant_id = 44759620649137;
                const free_gift_lines = parsedState.items.filter(line => line.variant_id == free_gift_variant_id && line.properties?.["_free_gift"] == "true");
                let free_gift_applied = !!free_gift_lines.length;

                free_gift_lines.filter(line => line.final_price > 0).forEach(lineToRemove => {
                  let removeFormData = {
                    'id': lineToRemove.key,
                    'quantity': 0
                  };
                  fetch(window.Shopify.routes.root + 'cart/change.js', {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify(removeFormData)
                  });
                });

                if (parsedState.items_subtotal_price >= 4900) {
                  const removedCookie = document.cookie.match(/removed_free_gift=(\d+)/)?.[1] ?? "";
                  if (removedCookie == free_gift_variant_id) {
                    $(".free-gift-box .atc-btn").show();
                  } else if (!free_gift_applied) {
                    const addFormData = {
                      items: [{
                        id: free_gift_variant_id,
                        properties: { '_free_gift': 'true' },
                        quantity: 1
                      }],
                      sections: this.cart.getSectionsToRender().map((section) => section.section),
                      sections_url: window.location.pathname
                    };
                    fetch(window.Shopify.routes.root + 'cart/add.js', {
                      method: 'POST',
                      headers: {'Content-Type': 'application/json'},
                      body: JSON.stringify(addFormData)
                    }).then(response => response.text()).then(innerState => {
                      const innerParsedState = JSON.parse(innerState);
                      const undiscounted = innerParsedState.items.filter(item => item.final_price > 1);
                      if (undiscounted.length) {
                        undiscounted.forEach(item => {
                          const removeFormData = {
                            id: item.key,
                            quantity: 0,
                            sections: this.cart.getSectionsToRender().map((section) => section.section),
                            sections_url: window.location.pathname
                          };
                          fetch(window.Shopify.routes.root + 'cart/change.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify(removeFormData)
                          }).then((response) => {
                            return response.text();
                          }).then((innerInnerState) => {
                            const innerInnerParsedState = JSON.parse(innerInnerState);
                            this.cart.renderContents(innerInnerParsedState);
                          });
                        });
                      }
                      this.cart.renderContents(innerParsedState);
                    });
                  }
                } else {
                  if (free_gift_lines.length) {
                    free_gift_lines.forEach(line => {
                      const removeFormData = {
                        id: line.key,
                        quantity: 0,
                        sections: this.cart.getSectionsToRender().map((section) => section.section),
                        sections_url: window.location.pathname
                      };
                      fetch(window.Shopify.routes.root + 'cart/change.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(removeFormData)
                      }).then((response) => {
                        return response.text();
                      }).then((state) => {
                        const parsedState = JSON.parse(state);
                        this.cart.renderContents(parsedState);
                      });
                    });
                  }
                }
              }
            });
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
